export const EXHIBITION_CARDS_DESKTOP = 5;
export const EXHIBITION_CARDS_MOBILE = 2;